import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';

const ModelTitleSummary = () => {
    const model = useSelector((state) => state.rootReducer);
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);

    return (
        <Box className={layout.subSectionContainer}>
            <h1 className={typography.modelPriceSummary}>
                {model.currentModel.currentModel.name} - {currency}
                {parseFloat(model.iemPrice.total).toFixed(2)}
            </h1>
        </Box>
    );
};

export default ModelTitleSummary;
